module.exports = __webpack_public_path__ + "img/mfd_in_2_pp4_name.dabe5a5d.png";